<script setup>
import pictoPts from "@/assets/images/picto-pts.png";
import pictoEurocora from "@/assets/images/picto-eurocora.png";
import carteCoraAvantage from "@/assets/images/carte-cora-avantage.png";
import illuEurocora from "@/assets/images/defis/illu-eurocora.svg";
import illuPointscora from "@/assets/images/defis/illu-points-cora.svg";
import illuCarrefourFid from "@/assets/images/carrefour-club-pass-card-ombre-incline.svg";
</script>
<script>
import Divider from "@/components/atoms/divider";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";
import DividerHeading from "@/components/molecules/divider-heading";

export default {
  name: "CommandeMesAvantages",
  components: { Divider, LazyImage, Button, DividerHeading },
  props: {
    points: {
      type: [String, Number],
      required: false,
      default: null
    },
    eurocora: {
      type: [String, Number],
      required: false,
      default: null
    },
    objets: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    isPorteurCarteCora: {
      type: Boolean,
      required: false,
      default: false
    },
    isPorteurCarteMalin: {
      type: Boolean,
      required: false,
      default: false
    },
    isEligibleDefis: {
      type: Boolean,
      required: false,
      default: false
    },
    typeFidelite: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ["addCarte"],
  data() {
    return {};
  },
  computed: {
    hasCarte() {
      return this.isPorteurCarteCora || this.isPorteurCarteMalin;
    }
  },
  methods: {
    addCarte() {
      this.$emit("addCarte");
    }
  }
};
</script>

<template>
  <div>
    <template v-if="points || eurocora">
      <template v-if="typeFidelite === 'CORA'">
        <div class="u-flex u-flex-align-center">
          <LazyImage
            :src="carteCoraAvantage"
            width="50"
            height="35"
            class="u-flex-shrink-none"
            alt=""
          />
          <p class="u-ml-sm u-font-17">
            Grâce à cette commande, vous collectez sur votre carte fidélité
          </p>
        </div>
        <div class="u-text-center u-mt-sm">
          <div class="u-inline-flex u-flex-justify-center@sm">
            <div class="u-color-primary u-inline-flex u-flex-align-center u-mr-sm">
              <LazyImage
                :src="isEligibleDefis ? illuEurocora : pictoEurocora"
                alt="eurocora"
                class="u-mr-xs"
                width="32"
                height="32"
              />
              <p>
                <span class="u-font-18 u-font-700 u-color-primary">{{ euroCora(eurocora) }}</span>
                <span class="u-color-primary u-font-11">€urocora</span>
              </p>
            </div>
            <Divider
              vertical
              dotted
            />
            <div class="u-color-primary u-inline-flex u-flex-align-center u-ml-sm">
              <LazyImage
                :src="isEligibleDefis ? illuPointscora : pictoPts"
                alt="points"
                class="u-mr-xs"
                width="32"
                height="32"
              />
              <p>
                <span class="u-color-points-color u-font-18 u-font-700">{{ pointFidelite(points) }}</span>
                <span class="u-color-points-color u-font-11">Points</span>
              </p>
            </div>
          </div>
          <div class="u-mt-md">
            <Button
              variant="primary"
              radius="full"
              size="sm"
              to="/mon-compte/ma-fidelite"
            >
              Voir tous mes avantages
            </Button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="u-flex">
          <LazyImage
            :src="illuCarrefourFid"
            width="64"
            height="44"
            alt=""
            class="u-flex-shrink-none"
          />
          <div class="u-ml-sm">
            <p class="u-font-17">
              Grâce à cette commande, vous collectez sur votre Carte Club ou votre Carte PASS
            </p>
            <div class="u-mt-sm">
              <p class="u-font-700  u-font-30">{{ euroCora(eurocora ?? "0.00") }} <span class="u-font-17">€</span></p>
              <p class="u-font-12">Cagnotte actualisée tous les soirs.</p>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-if="objets.length > 0">
      <div class="u-mt-md u-mb-md">
        <Divider dotted />
      </div>
      <div class="u-color-primary">
        <ul>
          <li
            v-for="(objet, index) in objets"
            :key="`objets-commande--${index}`"
            class="u-mb-sm u-font-15"
          >
            {{ objet.valeur }} {{ uppercaseFirstLetter(lowercase(objet.libelle)) }} {{ pluralize(objet.valeur, "collecté(e)") }}
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
</style>
